import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23">
    <path fill="#1D1D1B" fillRule="evenodd" d="M4.96 4.376v5.008h12.615v3.928H4.96v5.008h16.975v3.928H.607V.448h21.33v3.928z" />
  </svg>
);
